import { getPrivacyPolicy, getTermsAndConditions } from 'src/services/oms'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { NextPageContext } from 'next'
import type { MetaStateInReducer } from '../meta'

export const fetchTermsAndConditions = createAsyncThunk(
  '@agreements/terms-and-conditions',
  async (
    {
      isServer,
      req
    }: {
      isServer: boolean
      req: NextPageContext['req']
    },
    thunkApi
  ) => {
    const state = thunkApi.getState() as MetaStateInReducer

    const menuId = state['@meta'].detailMenuSite.data.menu.id

    const result = await getTermsAndConditions(menuId, isServer)
    return result.data
  }
)

export const fetchPrivacyPolicy = createAsyncThunk(
  '@agreements/privacy-policy',
  async ({ isServer, req }: any, thunkApi) => {
    const state = thunkApi.getState() as MetaStateInReducer
    const menuId = state['@meta'].detailMenuSite.data.menu.id as string

    const result = await getPrivacyPolicy(menuId, isServer)
    return result.data
  }
)
